import {getUrlParams, GoingNewUtils, isEmpty, StorageUtils} from "xmgoing-utils";
import {PageEnum} from "@/enums/pageEnum";

/**
 * 登录系统 session缓存
 * @param res
 */
export function loadSystemSessionCache(res:any){
  //普通登录才会存在loginUserType
  const loginUserType=(res as any).position||getUrlParams(PageEnum.LOGIN_USER_TYPE,true)||StorageUtils.getSessionItem(PageEnum.LOGIN_USER_TYPE);
  //如果是模版预览 或者应用预览 pageType 为APPShow
  const pageType=getUrlParams(PageEnum.PAGE_TYPE,true)||StorageUtils.getSessionItem(PageEnum.PAGE_TYPE);
  //开发态打开的时候  没有loginUserType
  if(loginUserType&&isEmpty(pageType)){
    StorageUtils.removeSessionItem(PageEnum.PAGE_TYPE);
    StorageUtils.removeSessionItem(PageEnum.SHOW_TYPE);
    StorageUtils.addSessionItem(PageEnum.SHOW_TYPE,PageEnum.RUNNING_APP);
    StorageUtils.addSessionItem(PageEnum.LOGIN_USER_TYPE,loginUserType);
  }else{
    StorageUtils.removeSessionItem(PageEnum.LOGIN_USER_TYPE);
    if(pageType===PageEnum.APP_SHOW){
      StorageUtils.addSessionItem(PageEnum.PAGE_TYPE,pageType);
      StorageUtils.addSessionItem(PageEnum.SHOW_TYPE,getUrlParams(PageEnum.SHOW_TYPE,true)||StorageUtils.getSessionItem(PageEnum.SHOW_TYPE));
    }else{
      StorageUtils.removeSessionItem(PageEnum.PAGE_TYPE);
      StorageUtils.removeSessionItem(PageEnum.PAGE_TYPE);
    }
  }
}

/**
 * 获取当前界面的显示类型
 */
export function getCurShowType():string{
  return StorageUtils.getSessionItem(PageEnum.SHOW_TYPE);
}

/**
 * 获取当前界面类型 主要是running 和 appShow 俩种
 */
export function getCurPageType():string{
  return getUrlParams(PageEnum.PAGE_TYPE,true)||StorageUtils.getSessionItem(PageEnum.PAGE_TYPE)
}

